import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import slugify from 'slugify';
import { injectStyles } from 'injectStyles';
import * as cssVariable from 'cssVariables';

import { BreadcrumbsSchema, PageTypeSchema } from 'components/Schema';
import PageHeader from 'components/PageHeader';
import PageContent from 'components/PageContent';
import LoadingPage from 'components/pages/status/LoadingPage';
import NotFoundPage from 'components/pages/status/NotFoundPage';
import { FaqCategoryHoc } from 'components/FaqCategory';
import { faqContentTypes } from 'actions/actions-const';
import { CONTACT_PAGE_TITLE } from 'globalConst/const';
import { SCHEMA_PAGE_TYPE } from 'globalConst/schema-const';

const GENERAL_CATEGOERY = 'Algemeen';
class FaqContactPage extends PureComponent {
  static defaultProps = {
    title: null,
    hidePlayer: false,
    hideSearch: false,
    mopinionId: null,
    isError: false,
    isLoading: false,
  };

  static propTypes = {
    title: PropTypes.string,
    classes: PropTypes.object.isRequired,
    hidePlayer: PropTypes.bool,
    hideSearch: PropTypes.bool,
    forceMiniPlayerState: PropTypes.func.isRequired,
    mopinionId: PropTypes.string,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    setSearchHidden: PropTypes.func.isRequired,
  };

  state = {
    isLoadingForm: true,
    relatedCategory: null,
    showEmailFallback: false,
  };

  componentDidMount() {
    this.watchIntput();
  }

  componentDidUpdate() {
    const { hidePlayer, hideSearch } = this.props;
    if (hidePlayer) {
      this.props.forceMiniPlayerState(true);
    }
    if (hideSearch) {
      this.props.setSearchHidden(true);
    }
  }

  componentWillUnmount() {
    const { hidePlayer, hideSearch } = this.props;
    if (hidePlayer) {
      this.props.forceMiniPlayerState(false);
    }
    if (hideSearch) {
      this.props.setSearchHidden(false);
    }
    if (this.watchInputTimeout) {
      clearTimeout(this.watchInputTimeout);
    }
    this.observer.disconnect();
  }

  loadRelatedCategory = (name) => {
    const slug = slugify(name, {
      replacement: '-',
      remove: undefined,
      lower: true,
    });
    this.setState({ relatedCategory: slug });
  };

  observer = new MutationObserver((mutations) =>
    mutations.forEach((mutation) => mutation.target && this.loadRelatedCategory(mutation.target.data))
  );

  watchInputCounter = 0;

  watchIntput = () => {
    const el = document.querySelector('.current');

    if (!el) {
      // No form is yet displayd
      if (this.watchInputCounter < 3) {
        this.watchInputCounter = this.watchInputCounter + 1;
        this.watchInputTimeout = setTimeout(this.watchIntput, 1000);
      } else {
        // Form is not available - show fallback
        this.setState({ showEmailFallback: true, isLoadingForm: false });
        this.loadRelatedCategory(GENERAL_CATEGOERY);
      }
      return;
    }

    this.setState({ isLoadingForm: false });
    this.loadRelatedCategory(el.innerText);
    this.observer.observe(el, {
      characterData: true,
      subtree: true,
    });
  };

  render() {
    const { classes, mopinionId, isLoading, isError } = this.props;

    const { isLoadingForm, relatedCategory, showEmailFallback } = this.state;

    if (isLoading) {
      return <LoadingPage />;
    }

    if (isError) {
      return <NotFoundPage />;
    }

    return (
      <div className={classes.contact}>
        <PageTypeSchema type={SCHEMA_PAGE_TYPE.CONTACT_PAGE} />
        <PageHeader {...this.props} />
        <BreadcrumbsSchema level2={CONTACT_PAGE_TITLE} />
        <PageContent>
          {mopinionId && <div data-testid="mopinion" id={mopinionId} />}
          {isLoadingForm && <LoadingPage />}
          {showEmailFallback && (
            <p className={classes.text}>
              Heb je een vraag aan JUKE? Dat mag natuurlijk altijd. Je kunt ons bereiken via{' '}
              <a href="mailto:support@juke.nl">support@juke.nl</a>
            </p>
          )}
          {relatedCategory && (
            <FaqCategoryHoc
              title="Gerelateerde vragen"
              icon={null}
              showQuestions
              showAnswers
              isInContact
              contentType={faqContentTypes.CATEGORY}
              slug={relatedCategory}
            />
          )}
        </PageContent>
      </div>
    );
  }
}

const styles = {
  contact: {
    margin: 'auto',
    maxWidth: 780,
    '& *': {
      fontFamily: cssVariable.fontFamily,
    },
    '& .control-group, & .form-actions': {
      padding: '20px 2px !important',
    },
  },
  text: {
    fontSize: 18,
    lineHeight: 1.33,
    color: cssVariable.grey500,
    paddingBottom: 40,
  },
};

export default injectStyles(styles)(FaqContactPage);
